// import FranklinBenjaminEmbed from "../images/FranklinBenjaminEmbed";
import FranklinBenjaminAltEmbed from "../images/FranklinBenjaminAltEmbed";
import Franklin from "../Thumbs/Franklin60.jpg";

const FranklinBenjamin = {
    objectName: 'FranklinBenjamin',
    firstName: 'Benjamin',
    lastName: 'Franklin',
    dates: '1706-1790',
    id: 'Franklin1706-1790',
    image: FranklinBenjaminAltEmbed,
    thumbImg: Franklin,
    quotes: [
    {
        tabHeading: 'Ben Franklin - Const Convention Speech',
        metaDescription: `Benjamin Franklin's speech from the Constitutional Convention, June 28, 1787.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Constitutional Convention Speech',
        id: 'CCS28June1787',
        date: 'June 28, 1787',
        headTitle: `Benjamin Franklin - Constitutional Convention Speech`,
        headDescription: `Benjamin Franklin's speech from the Constitutional Convention, June 28, 1787.`,
        content: [
              {bold: `June 28, 1787`},
              {normal: `Mr. President`},
              {normal: `The small progress we have made after four or five weeks close attendance and continual reasoning’s with each other, our different sentiments 
            on almost every question, several of the last producing as many no’s as ayes, is methinks a melancholy proof of the imperfection of the Human Understanding. 
            We indeed seem to feel our own want of political wisdom, since we have been running about in search of it. We have gone back to ancient history for models 
            of Government, and examined the different forms of those Republics which having been formed with the seeds of their own dissolution now no longer exist. 
            And we have viewed Modern States all 'round Europe but find none of their Constitutions suitable to our circumstances.`},
              {bold: `In this situation of this Assembly, groping as it were in the dark to find political truth and scarce able to distinguish it when presented to us, 
            how has it happened, Sir, that we have not hitherto once thought of humbly applying to the Father of Lights to Illuminate our Understandings?`, normal: ` In 
            the beginning of the Contest with Great Britain, when we were sensible of danger, we had daily prayer in this room for the Divine Protection. Our prayers, 
            Sir, were heard, and they were graciously answered. All of us who were engaged in the struggle must have observed frequent instances of a Superintending 
            Providence in our favor. To that kind Providence we owe this happy opportunity of consulting in peace on the means of establishing our future national 
            felicity. And `, bold2: `have we now forgotten that powerful Friend? Or do we imagine that we no longer need His assistance?`},
              {bold: `I have lived, Sir, a long time, and the longer I live, the more convincing proofs I see of this truth, that God Governs in the Affairs of Men. 
            And if a sparrow cannot fall to the ground without His notice, is it probable that an Empire can rise without His aid? We have been assured, Sir, in the 
            Sacred Writings, that "except the Lord build the House, they labour in vain that build it." I firmly believe this; and I also believe that without His 
            concurring aid we shall succeed in this political building no better, than the Builders of Babel.`, normal: ` We shall be divided by our little partial 
            local interests; our projects will be confounded, and we ourselves shall become a reproach and bye word down to future ages. And what is worse, mankind 
            may hereafter from this unfortunate instance, despair of establishing Governments by Human wisdom and leave it to chance, war and conquest.`},
              {bold: `I therefore beg leave to move that henceforth, prayers imploring the assistance of Heaven, and its Blessings on our deliberations, be held in 
            this Assembly every morning before we proceed to business, and that one or more of the Clergy of this City be requested to officiate in that Service.`}
        ],
        considerations: [
            {
                name: '',
                title: 'Ronald Reagan',
                date: '',
                content: [`If we ever forget that we are one nation under God, then we will be a nation gone under.`]
            },
            {
              name: '',
              title: 'Thomas Jefferson',
              date: '',
              content: [`God who gave us life gave us liberty. And can the liberties of a nation be thought secure when we have removed their only firm basis, a 
            conviction in the minds of the people that these liberties are of the Gift of God? That they are not to be violated but with His wrath? Indeed, I 
            tremble for my country when I reflect that God is just; that His justice cannot sleep forever; That a revolution of the wheel of fortune, a change of 
            situation, is among possible events; that it may become probable by Supernatural influence! The Almighty has no attribute which can take side with us 
            in that event.`]
          }
        ]
    }    
]};

export default FranklinBenjamin;